module.exports = __webpack_public_path__ + "static/media/rw.85f6ca97.svg";